import { render, staticRenderFns } from "./AttachmentPreview.vue?vue&type=template&id=1ca1a7af&scoped=true&"
import script from "./AttachmentPreview.vue?vue&type=script&lang=js&"
export * from "./AttachmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentPreview.vue?vue&type=style&index=0&id=1ca1a7af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1a7af",
  null
  
)

export default component.exports